var exports = {
  "zr": "ChessBoard.module__root___MWRHNE",
  "OC": "ChessBoard.module__player___MWRHNE",
  "Xu": "ChessBoard.module__playerName___MWRHNE",
  "pm": "ChessBoard.module__clock___MWRHNE",
  "no": "ChessBoard.module__board___MWRHNE",
  "Ew": "ChessBoard.module__square___MWRHNE",
  "BB": "ChessBoard.module__light___MWRHNE",
  "XT": "ChessBoard.module__dark___MWRHNE",
  "fV": "ChessBoard.module__piece___MWRHNE",
  "C6": "ChessBoard.module__whitePiece___MWRHNE",
  "cq": "ChessBoard.module__blackPiece___MWRHNE",
  "z3": "ChessBoard.module__error___MWRHNE",
};

module.exports = exports;
